import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col rounded-2xl p-2 bg-gray-200"
}
const _hoisted_3 = { class: "flex flex-col w-full items-end" }
const _hoisted_4 = { class: "border-2 rounded-md border-primary-color-500" }
const _hoisted_5 = {
  key: 0,
  class: "flex justify-end w-full bg-white rounded-b-lg p-2 border-t border-t-gray-200 gap-x-1"
}
const _hoisted_6 = {
  key: 2,
  class: "flex flex-col rounded-2xl p-2 bg-gray-200"
}
const _hoisted_7 = { class: "flex flex-col w-full items-end" }
const _hoisted_8 = { class: "flex flex-col gap-y-3 bg-white w-80 rounded-lg px-3 py-2 leading-5 font-normal" }
const _hoisted_9 = { class: "flex justify-between" }
const _hoisted_10 = { class: "text-xs text-gray-400" }

import { computed, ref } from "vue"
import GgmsButton from "@/components/GgmsButton.vue"
import GgmsTextarea from "@/components/GgmsTextarea.vue"
import { Position } from "@vue-flow/core"
import { NodeToolbar } from "@vue-flow/node-toolbar"
import { AnnotationIcon, XIcon, TrashIcon } from "@heroicons/vue/outline"
import { AnnotationIcon as SolidAnnotationIcon } from "@heroicons/vue/solid"
import { formatTaskDate } from "@/shared/utils/helpers"
interface Props {
    note?: { text?: string; lastEdited?: string }
    isNoteVisible?: boolean
    status: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ToolbarNode',
  props: {
    note: {},
    isNoteVisible: { type: Boolean },
    status: {}
  },
  emits: ["update:note", "update:status", "update:noteVisible"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const value = ref(props.note?.text)
const initialValue = ref(props.note?.text)

const showButtons = ref(false)

const savingDate = ref(props.note?.lastEdited)

const localNoteVisible = computed({
    get() {
        return props.isNoteVisible
    },
    set(value) {
        emits("update:noteVisible", value)
    },
})

const localStatus = computed({
    get() {
        return props.status
    },
    set(value) {
        emits("update:status", value)
    },
})
function onInput() {
    showButtons.value = true
}

function editNote() {
    localStatus.value = "editOpen"
    showButtons.value = true
}

function cancel() {
    value.value = initialValue.value
    if (value.value.length) {
        localStatus.value = "fullClosed"
    } else {
        localStatus.value = "emptyClosed"
        localNoteVisible.value = false
    }
    showButtons.value = false
}
function save() {
    savingDate.value = formatTaskDate(new Date())
    showButtons.value = false
    if (!value.value?.length) {
        localStatus.value = "emptyClosed"
        localNoteVisible.value = false
    } else {
        localStatus.value = "fullClosed"
    }
    initialValue.value = value.value
    emits("update:note", { text: value.value, lastEdited: savingDate.value })
}

function closeToolbar() {
    if (localStatus.value === "fullOpen") {
        localStatus.value = "fullClosed"
        return
    }
    if (localStatus.value === "editOpen" && initialValue.value?.length) {
        cancel()
        localStatus.value = "fullClosed"
        return
    }
    localNoteVisible.value = false
    if (localStatus.value === "editOpen" && value.value?.length) {
        cancel()
        localStatus.value = "fullClosed"
        return
    }
    if (localStatus.value === "editOpen" && !value.value?.length) {
        localStatus.value = "emptyClosed"
        return
    }
}

function deleteNote() {
    value.value = ""
    initialValue.value = ""
    save()
}

function openEdit() {
    localStatus.value = "editOpen"
    initialValue.value = value.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NodeToolbar), {
    class: "flex gap-x-2 nodrag nopan",
    "is-visible": localNoteVisible.value,
    position: _unref(Position).Right,
    align: "start"
  }, {
    default: _withCtx(() => [
      (_ctx.status === 'emptyClosed' || _ctx.status === 'fullClosed')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (value.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "bg-gray-200 p-2 rounded-lg cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (localStatus.value = 'fullOpen'))
                }, [
                  _createVNode(_unref(SolidAnnotationIcon), { class: "h-5 w-5" })
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "bg-gray-200 p-2 rounded-lg cursor-pointer",
                  onClick: openEdit
                }, [
                  _createVNode(_unref(AnnotationIcon), { class: "h-5 w-5" })
                ]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.status === 'editOpen')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(XIcon), {
                class: "w-5 h-5 text-gray-500 cursor-pointer",
                onClick: closeToolbar
              }),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(GgmsTextarea, {
                  modelValue: value.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
                  rows: 1,
                  borderless: "",
                  "rounded-top": "",
                  "rounded-bottom": !showButtons.value,
                  rounded: false,
                  placeholder: "Write a note...",
                  class: "w-80",
                  onInput: onInput
                }, null, 8, ["modelValue", "rounded-bottom"]),
                (showButtons.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(GgmsButton, {
                        "style-type": "secondary",
                        onClick: cancel
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Cancel")
                        ]),
                        _: 1
                      }),
                      _createVNode(GgmsButton, { onClick: save }, {
                        default: _withCtx(() => [
                          _createTextVNode("Done")
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.status === 'fullOpen')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(XIcon), {
                class: "w-5 h-5 text-gray-500 cursor-pointer",
                onClick: closeToolbar
              }),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", {
                  class: "text-sm text-gray-800",
                  onClick: editNote
                }, _toDisplayString(value.value), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", _hoisted_10, "Last edited " + _toDisplayString(savingDate.value), 1),
                  _createVNode(_unref(TrashIcon), {
                    class: "w-5 h-5 text-gray-500 cursor-pointer",
                    onClick: deleteNote
                  })
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["is-visible", "position"]))
}
}

})